/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M17 8V13.5M6 6L8.12854 8.12854M18 18L16.1427 16.1427M16.1427 16.1427C15.3247 17.2682 13.9978 18 12.5 18C10.0147 18 8 15.9853 8 13.5V9C8 8.69691 8.04495 8.40432 8.12854 8.12854M16.1427 16.1427L13.9357 13.9357M13.9357 13.9357C13.7491 14.5517 13.1769 15 12.5 15C11.6716 15 11 14.3284 11 13.5V12.25V11M13.9357 13.9357L11 11M11 11L8.12854 8.12854M10 6.17071C10.3128 6.06015 10.6494 6 11 6C12.6569 6 14 7.34315 14 9V10.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M17 8V13.5M16.1427 16.1427L18 18M16.1427 16.1427C15.3247 17.2682 13.9978 18 12.5 18C10.0147 18 8 15.9853 8 13.5V9C8 8.69691 8.04495 8.40432 8.12854 8.12854M16.1427 16.1427L13.9357 13.9357M13.9357 13.9357C13.7491 14.5517 13.1769 15 12.5 15C11.6716 15 11 14.3284 11 13.5V12.25V11M13.9357 13.9357L11 11M11 11L8.12854 8.12854M6 6L8.12854 8.12854M10 6.17071C10.3128 6.06015 10.6494 6 11 6C12.6569 6 14 7.34315 14 9V10.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM6.53033 5.46967C6.23744 5.17678 5.76256 5.17678 5.46967 5.46967C5.17678 5.76256 5.17678 6.23744 5.46967 6.53033L7.30376 8.36442C7.26838 8.57136 7.25 8.78376 7.25 9V13.5C7.25 16.3995 9.6005 18.75 12.5 18.75C13.9347 18.75 15.2349 18.174 16.1818 17.2425L17.4697 18.5303C17.7626 18.8232 18.2374 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L16.673 15.6124L14.4661 13.4054L11.5303 10.4697L8.65887 7.59821L6.53033 5.46967ZM8.75 13.5V9.81066L10.25 11.3107V12.25V13.5C10.25 14.7426 11.2574 15.75 12.5 15.75C13.1064 15.75 13.656 15.5103 14.0603 15.121L15.1212 16.1818C14.4445 16.8435 13.5197 17.25 12.5 17.25C10.4289 17.25 8.75 15.5711 8.75 13.5ZM11.75 13.5V12.8107L12.9992 14.0599C12.8664 14.1782 12.6912 14.25 12.5 14.25C12.0858 14.25 11.75 13.9142 11.75 13.5ZM10.2499 6.87784C10.4836 6.79526 10.7357 6.75 11 6.75C12.2426 6.75 13.25 7.75736 13.25 9V10.5C13.25 10.9142 13.5858 11.25 14 11.25C14.4142 11.25 14.75 10.9142 14.75 10.5V9C14.75 6.92893 13.0711 5.25 11 5.25C10.563 5.25 10.142 5.32505 9.75006 5.46358C9.35953 5.60161 9.15483 6.0301 9.29287 6.42064C9.43091 6.81118 9.8594 7.01587 10.2499 6.87784ZM17.75 8C17.75 7.58579 17.4142 7.25 17 7.25C16.5858 7.25 16.25 7.58579 16.25 8V13.5C16.25 13.9142 16.5858 14.25 17 14.25C17.4142 14.25 17.75 13.9142 17.75 13.5V8Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M17 8V13.5M16.1427 16.1427L18 18M16.1427 16.1427C15.3247 17.2682 13.9978 18 12.5 18C10.0147 18 8 15.9853 8 13.5V9C8 8.69691 8.04495 8.40432 8.12854 8.12854M16.1427 16.1427L13.9357 13.9357M13.9357 13.9357C13.7491 14.5517 13.1769 15 12.5 15C11.6716 15 11 14.3284 11 13.5V12.25V11M13.9357 13.9357L11 11M11 11L8.12854 8.12854M6 6L8.12854 8.12854M10 6.17071C10.3128 6.06015 10.6494 6 11 6C12.6569 6 14 7.34315 14 9V10.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M17 8V13.5M16.1427 16.1427L18 18M16.1427 16.1427C15.3247 17.2682 13.9978 18 12.5 18C10.0147 18 8 15.9853 8 13.5V9C8 8.69691 8.04495 8.40432 8.12854 8.12854M16.1427 16.1427L13.9357 13.9357M13.9357 13.9357C13.7491 14.5517 13.1769 15 12.5 15C11.6716 15 11 14.3284 11 13.5V12.25V11M13.9357 13.9357L11 11M11 11L8.12854 8.12854M6 6L8.12854 8.12854M10 6.17071C10.3128 6.06015 10.6494 6 11 6C12.6569 6 14 7.34315 14 9V10.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L8.65887 7.59821L11.5303 10.4697L14.4661 13.4054L16.673 15.6124L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L16.1818 17.2425C15.2349 18.174 13.9347 18.75 12.5 18.75C9.6005 18.75 7.25 16.3995 7.25 13.5V9C7.25 8.78376 7.26838 8.57136 7.30376 8.36442L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967ZM8.75 9.81066V13.5C8.75 15.5711 10.4289 17.25 12.5 17.25C13.5197 17.25 14.4445 16.8435 15.1212 16.1818L14.0603 15.121C13.656 15.5103 13.1064 15.75 12.5 15.75C11.2574 15.75 10.25 14.7426 10.25 13.5V12.25V11.3107L8.75 9.81066ZM11.75 12.8107V13.5C11.75 13.9142 12.0858 14.25 12.5 14.25C12.6912 14.25 12.8664 14.1782 12.9992 14.0599L11.75 12.8107ZM11 6.75C10.7357 6.75 10.4836 6.79526 10.2499 6.87784C9.8594 7.01587 9.4309 6.81118 9.29287 6.42064C9.15483 6.0301 9.35953 5.60161 9.75007 5.46358C10.142 5.32505 10.563 5.25 11 5.25C13.0711 5.25 14.75 6.92893 14.75 9V10.5C14.75 10.9142 14.4142 11.25 14 11.25C13.5858 11.25 13.25 10.9142 13.25 10.5V9C13.25 7.75736 12.2426 6.75 11 6.75ZM17 7.25C17.4142 7.25 17.75 7.58579 17.75 8V13.5C17.75 13.9142 17.4142 14.25 17 14.25C16.5858 14.25 16.25 13.9142 16.25 13.5V8C16.25 7.58579 16.5858 7.25 17 7.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
